import { useRef, useState } from "react";
import GenerateLinkContent from "./generateLinkContent";
import UsersContent from "./usersContent";
import AdminContent from "./adminCntents";

export let ConfigData = []

export default function PanelContent({ item }) {
    const [refresh, setRefresh] = useState(0)
    const Refresh = async () => {
        setRefresh(refresh + 1)
    }

    switch (item) {
        case '-1':
            return (<GenerateLinkContent onChange={() => Refresh()}></GenerateLinkContent>)
            break
        case '0':
            return (<UsersContent onChange={() => Refresh()}></UsersContent>)
            break
        case '1':
            return (<AdminContent onChange={() => Refresh()}></AdminContent>)
            break
    }


    return (
        <></>
    )
}